<script>
import Text from '../components/Text.svelte';
import Button from '../components/Button.svelte';
import {fade} from "svelte/transition";
import { navigateTo} from 'yrv';
</script>

<svelte:head>
	<title>About JourneyMaps.app</title>
</svelte:head>




<div in:fade>

<h1>JourneyMaps.app</h1>
<p class="intro">Built by people that care about your customers as much as you should.</p>
<p><button class="button" on:click={()=>{navigateTo('/')}}><span>Next</span></button></p>
</div>